import {
  confirmarCadastroRespostaSchema,
  prepararCadastroRespostaSchema,
  validarCodigoRespostaSchema,
} from '@varga/shared';
import { api } from '../lib/http';

/** Corpo de `POST /v1/cadastro/preparar` (datas como string ISO — a API coage). */
export interface PrepararCadastroBody {
  nome: string;
  telefone: string;
  numeroOs: string;
  servico: string;
  valor?: number;
  documento?: string;
  email?: string;
  veiculo?: { placa: string; marca?: string; modelo?: string; ano?: number };
  placa?: string;
  codigoErp?: string;
  finalizadaEm?: string;
  codigoIndicacao?: string;
  /** sem default (SPEC §9) — "Não sei" no segmentado bloqueia antes de chegar aqui */
  clienteNovo: boolean;
}

/** `POST /v1/cadastro/preparar` — normaliza e devolve um rascunho (TTL 15 min). */
export function prepararCadastro(input: PrepararCadastroBody) {
  return api(prepararCadastroRespostaSchema, '/v1/cadastro/preparar', {
    method: 'POST',
    body: input,
  });
}

/** `POST /v1/cadastro/confirmar` — roda as 8 regras, converte, concede vouchers. */
export function confirmarCadastro(rascunhoId: string) {
  return api(confirmarCadastroRespostaSchema, '/v1/cadastro/confirmar', {
    method: 'POST',
    body: { rascunhoId },
  });
}

/** `POST /v1/codigos/validar` — dry-run das 8 regras (botão "Validar código"). */
export function validarCodigo(codigo: string, clienteNovo: boolean) {
  return api(validarCodigoRespostaSchema, '/v1/codigos/validar', {
    method: 'POST',
    body: { codigo, clienteNovo },
  });
}
